"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const marked_ts_1 = require("marked-ts");
class Poster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
        this.createMarkup = (content) => {
            return { __html: content };
        };
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    render() {
        if (!this.state.open) {
            return null;
        }
        const { content } = this.props;
        const markedContent = marked_ts_1.Marked.parse(content);
        return (React.createElement("div", { className: "Banner" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "close-button" },
                    React.createElement("button", { className: "icon-button", onClick: () => this.setState({ open: false }) },
                        React.createElement("img", { src: icons_1.closeWhiteSmallIcon, alt: "" }))),
                React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup(markedContent) }))));
    }
}
exports.Poster = Poster;
exports.default = Poster;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-poster/Poster.tsx